var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .937h13.999v14H0v-14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M12.572 7.134h-1.201V3.237c0-.537-1.011-1.337-2.26-1.337H4.732c-1.248 0-2.26.8-2.26 1.337v3.897h-1.2a.56.56 0 0 0-.565.557v6.682a.56.56 0 0 0 .565.556h11.3a.56.56 0 0 0 .565-.556V7.691a.56.56 0 0 0-.565-.557zM3.743 3.237c0-.538.444-.975.989-.975h4.379c.546 0 .989.437.989.975v3.897H3.743V3.237zm8.123 10.44H1.978v-5.29h9.888v5.29zm-5.439-2.419v.922a.14.14 0 0 0 .142.139h.706a.14.14 0 0 0 .141-.139v-.922c.146-.103.255.642.311-.417a.823.823 0 0 0 .002-.517c-.055-.169-.163.476-.308-.42a.857.857 0 0 0-.998 0c-.145.896-.253.251-.308.42.485.168.495.349.002.517.056 1.059.165.314.31.417z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLock);
export default __webpack_public_path__ + "static/media/ico-lock.835cac7bcb90eb737c4ade954697c1d0.svg";
export { ForwardRef as ReactComponent };